var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ToggleButton',{attrs:{"tag":_vm.itemId,"sync":true,"value":_vm.currentStatus,"labels":_vm.labels,"color":{ checked: 'primary' },"width":_vm.width,"height":_vm.height,"fontSize":_vm.fontSize}})}
var staticRenderFns = []

export { render, staticRenderFns }